import React, { Component } from 'react';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson, esUrl} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';

export default class AdmEventoHome extends Component {
    constructor(props) {
        super(props); 
        this.state = { 
            modulo: this.props.modulo, 
            resource:{
                pmod_Id:0,
                pagi_Id:this.props.pagina,
                mweb_Id:this.props.modulo.id,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                meho_Titulo:"",
                meho_Enlace:"",
                meho_Activo:true
            },
            resourceEdit:{
                pmod_Id:0,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                meho_Id:0,
                meho_Titulo:"",
                meho_Enlace:"",
                meho_Activo:true
            },
            Validacion: {
                meho_Titulo: {
                    Error: false,                    
                },
                meho_Enlace: {
                    Error: false,                    
                }
            },
            ValidacionEdit:{
                meho_Titulo: {
                    Error: false,                    
                },
                meho_Enlace: {
                    Error: false,                    
                }
            },
            perfiles: this.props.perfiles,
            sectores: this.props.sectores,
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: []
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resource: copyResource,            
            Validacion: validaciones
        });  
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resourceEdit: copyResource,           
            ValidacionEdit: validaciones
        });  
    }

    storeBeneficioCliente = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.meho_Titulo == '') {              
            newState.Validacion.meho_Titulo = {Error: true};
            newState.hasError = true;
        }

        if (newState.resource.meho_Enlace !== '' && !esUrl(newState.resource.meho_Enlace)) {  
            newState.Validacion.meho_Enlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloEventoHomeUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'meho_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
            'Content-Type': 'application/json; charset=UTF-8' ,
            'Accept': 'application/json'
            }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                let result = data.data.result;
                let stateResponse = this.state;

                stateResponse.added = true;

                stateResponse.resource.meho_Titulo = '';
                stateResponse.resource.meho_Enlace = '';
                stateResponse.resource.pmod_Id = result.pmod_Id;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 

                this.props.callback(true);

                $(".divClosePopup_Modals").trigger("click");

            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
            console.log('Error no controlado.');
            this.setState({loading:false});
        });        
    }

    updateBeneficioCliente = (e) => {
        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.meho_Titulo == '') {              
            newState.ValidacionEdit.meho_Titulo = {Error: true};
            newState.hasError = true;
        }

        if (newState.resourceEdit.meho_Enlace !== '' && !esUrl(newState.resourceEdit.meho_Enlace)) {  
            newState.ValidacionEdit.meho_Enlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloEventoHomeUX/`;
        var dataForm = this.state.resourceEdit;
        dataForm = updateValueInJson(dataForm,'meho_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
            'Content-Type': 'application/json; charset=UTF-8' ,
            'Accept': 'application/json'
            }
        }
        ).then(
        (data)=> {             
            if (data.data.isSucess)
            {
                this.setState({added:true});

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
            console.log('Error no controlado.');
            this.setState({loading:false});
        });        
    }

    closeBeneficioCliente = () => {
        let resource = this.state.resource;
        resource.pmod_Id = 0;
        
        let resourceEdit = this.state.resourceEdit;
        resourceEdit.meho_Id = 0;
        this.setState({resource:resource, resourceEdit:resourceEdit});

        this.props.callback(true);
        
    }

    loadDetallePerfilador = (pmod_Id) => 
    {
        const url = `${API_URL}ModuloEventoHomeUX/Seleccionar/${pmod_Id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            this.setState({ resourceEdit: data.result, response: data, error: data.Error });           
        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });
    }    
    
    componentWillReceiveProps(nextProps){
        let mweb = 74;

        if(nextProps.pmodId !== this.state.resource.pmod_Id && mweb == nextProps.mWebEdit){
            let resource = this.state.resource;
            resource.pmod_Id = nextProps.pmodId;

            this.setState({resource: resource});

            setTimeout(() => { 
                this.loadDetallePerfilador(resource.pmod_Id);
            }, 100); 
        }
    } 

    render() {
        let modulo = this.state.modulo;

        return (
            <div className="divModalBanner popUpGeneral" id={"modal_" + modulo.id} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                    <div className="divClosePopup_Modals" onClick={() => this.closeBeneficioCliente()}/>
                    <h2>{modulo.nombre} </h2>
                    <div className="divWrapperModalPaginas">
                        {
                            this.state.resourceEdit.meho_Id > 0 ?
                            <React.Fragment>
                            <div className="containerFormCreation divModuloPopup_Panel">
                                {
                                    this.state.added ?
                                    <div className="txtFile x-1">
                                        <strong style={{
                                            display: "block",
                                            textAlign:"center",
                                            color: "#008000a3"
                                        }}> Registro actualizado satisfactoriamente!!</strong>
                                    </div> : null
                                }
                                

                                <div className="txtFile x-1">
                                    <input type="text" 
                                    placeholder="Título" 
                                    name='meho_Titulo' 
                                    value={this.state.resourceEdit.meho_Titulo} 
                                    maxLength={300} 
                                    className={this.state.ValidacionEdit.meho_Titulo.Error ? "error" : ""}  
                                    onChange={this.handleInputChangeEdit}/>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Enlace" 
                                    name='meho_Enlace' 
                                    value={this.state.resourceEdit.meho_Enlace} 
                                    className={this.state.ValidacionEdit.meho_Enlace.Error ? "error" : ""} 
                                    maxLength={500}  
                                    onChange={this.handleInputChangeEdit}/>
                                </div>
                            </div>
                            <div>
                                <a href="" className="btnAgregarPagina noneEvent" id="btnActualizarPerfilador" onClick={(e) => this.updateBeneficioCliente(e)}>ACTUALIZAR</a>
                                <br/>
                                <br/>
                                <br/>
                            </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <div className="containerFormCreation divModuloPopup_Panel">

                                    <div className="txtFile x-1">
                                        <input type="text" 
                                        placeholder="Título" 
                                        name='meho_Titulo' 
                                        value={this.state.resource.meho_Titulo} 
                                        maxLength={300} 
                                        className={this.state.Validacion.meho_Titulo.Error ? "error" : ""}  
                                        onChange={this.handleInputChange}/>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Enlace" 
                                        name='meho_Enlace' 
                                        value={this.state.resource.meho_Enlace} 
                                        className={this.state.Validacion.meho_Enlace.Error ? "error" : ""} 
                                        maxLength={500}  
                                        onChange={this.handleInputChange}/>
                                    </div>
                                </div>
                                <div>
                                    <a href="" className="btnAgregarPagina noneEvent" id="btnGuardarPerfilador" onClick={(e) => this.storeBeneficioCliente(e)}>GUARDAR</a>
                                    <br/>
                                    <br/>
                                    <br/>
                                </div>
                            </React.Fragment>
                        }
                    </div>
                    </div>
                </div>
            </div>
        )
    }
}